<template>
  <div class>
    <div slot="header" class="clearfix" style="background-color: #f2f2f2; padding: 20px">
      <span style="font-weight: 600; color: #000; line-height: 10px">项目信息</span>
    </div>
    <div class>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px"  style="width: 400px; margin-top: 20px">
        <el-form-item label="项目名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入告警通知组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业名称" prop="companyName">
          <el-input
            type="textarea"
            v-model="form.companyName"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目地址" prop="areaCode">
          <el-cascader
            :options="optionsThree"
            v-model="form.areaCode"
            placeholder="请选择省市区"
            @change="handleChange"
            ref="three"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="" prop="address" style="width: 700px">
          <el-row>
            <el-col :span="12">
              <el-input
                style=""
                v-model="form.address"
                placeholder="请输入详细地址"
              >
              </el-input>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" round style="margin-left: 10px" @click="isShowMapClick">地图定位</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-show="isShowMap" label="" style="width: 1000px">
          <div id="container"></div>
          <div>当前定位：{{ newAddress }}</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="btns" style="margin-top:30px;display:flex;align-items:center;justify-content:center;">
      <el-button @click="cancel" class="resetbtn">取消</el-button>
      <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js";
import { HOST, EV_HOST } from "@/utils/host";
import { regionData,CodeToText } from "element-china-area-data";
let map = null; //高德地图
//import x from ''
export default {
  name: "tongzhiguanli",
  components: {},
  data() {
    return {
      optionsThree: regionData, //省市区数据
      isShowMap: false,
      newAddress: "",
      city: "", //省市区三级联动
      form: {
        name: "",
        companyName: "",
        areaCode: "",
        area:"",
        address: "",
        lng:0.0,
        lat:0.0
      },
      rules: {
        areaCode: [
          { required: true, message: "请选择项目地址", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  methods: {
    cancel() {
      this.form = {
        name: "",
        companyName: "",
        areaCode: "",
        area:"",
        address: "",
        lng:0.0,
        lat:0.0
      };
      this.newAddress = "";
      this.$router.go(-1);
    },
    save() {
      let data = {
        name: this.form.name,
        companyName: this.form.companyName,
        area:this.form.area,
        areaCode:this.form.areaCode,
        address:this.form.address,
        longitude:this.form.lng,
        latitude:this.form.lat,
        id: this.id
      };
      if(data.areaCode.constructor==Array){
        data.areaCode = data.areaCode.toString()
      }
      console.log(data,'dddddd',data.areaCode)
      this.$store.dispatch("form/handle", {
        url: "/battery/dcProject/update",
        data: data,
        method: "post",
        callback: (resp) => {
          this.$router.go(-1);
        },
      });
    },
    handleChange() {
      this.city = this.$refs.three.getCheckedNodes()[0].pathLabels.join(",");
      this.form.area = this.$refs.three.getCheckedNodes()[0].pathLabels.join(" > ");
      this.form.areaCode = this.form.areaCode.join(",");
    },
    isShowMapClick() {
      this.isShowMap = true;
      if(!this.city){
        for(var i=0;i<this.form.areaCode.length;i++){
          this.city += CodeToText[this.form.areaCode[i]]
        }
      }
      let address = this.city + this.form.address;
      this.markLocation("container", address);
    },
    markLocation(mapId, address) {
      console.log(address,'address')
      AMap.plugin("AMap.Geocoder", () => {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国",
        });
        //创建地图
        map = new AMap.Map(mapId, {
          zoom: 13,
          center: [120.220876, 33.423722],
        });
        geocoder.getLocation(address, (status, result) => {
          console.log(status,'fdfdfdf')
          if (status === "complete" && result.info === "OK") {
            // 经纬度
            var lng = result.geocodes[0].location.lng;
            var lat = result.geocodes[0].location.lat;
            // 添加标记
            let marker = new AMap.Marker({
              position: new AMap.LngLat(lng, lat), // 经纬度
            });
            map.add(marker); //加载点
            map.setFitView(); //缩放至地图

            geocoder.getAddress([lng, lat], (status, result) => {
              if (status === "complete" && result.info === "OK") {
                // result为对应的地理位置详细信息
                console.log(result.regeocode.formattedAddress);
                this.newAddress = result.regeocode.formattedAddress + "(" + lng + "," + lat + ")";
                this.form.lat = lat;
                this.form.lng = lng;
              }
            });
          } else {
            console.log("定位失败", status,address);
          }
        });

        //地图点击事件
        map.on("click", (e) => {
          map.clearMap(); //清理地图
          let lng = e.lnglat.getLng(); //获取经度
          let lat = e.lnglat.getLat(); //获取纬度
          var lnglat = [lng, lat];
          //marker点
          let marker = new AMap.Marker({
            position: lnglat,
            offset: new AMap.Pixel(-13, -30),
          });
          map.add(marker); //加载点
          map.setFitView(); //缩放至地图
          geocoder.getAddress(lnglat, (status, result) => {
            if (status === "complete" && result.info === "OK") {
              // result为对应的地理位置详细信息
              console.log(result.regeocode.formattedAddress);
              this.newAddress =
                result.regeocode.formattedAddress +
                "(" +
                lnglat[0] +
                "," +
                lnglat[1] +
                ")";
              this.form.lat = lnglat[1];
              this.form.lng = lnglat[0];
            }
          });
        });
      });
    },
  },
  mounted() {},
  created() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    let tmpData = this.$route.query.data;
    this.form = {
      name: tmpData.name,
      companyName: tmpData.companyName,
      areaCode: tmpData.areaCode.split(","),
      area: tmpData.area,
      address: tmpData.address,
      lng: tmpData.longitude,
      lat: tmpData.latitude
    };
    this.id = tmpData.id;
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
#container {
  width: 500px;
  height: 400px;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/modifyProject.vue